import { usePosterContext } from "../../../../../context/poster-context";

const Preview2Back = () => {
  const { background } = usePosterContext();
  return (
    <svg
      width="1132"
      height="1600"
      viewBox="0 0 1132 1600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25382_92306)">
        <g clip-path="url(#clip1_25382_92306)">
          <g clip-path="url(#clip2_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-1358.69 334)"
              fill="#080808"
            />
            <g filter="url(#filter0_f_25382_92306)">
              <circle cx="275.456" cy="752.658" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter1_f_25382_92306)">
              <circle
                cx="-74.0561"
                cy="906.345"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="-33.1934"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint0_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="17.5137"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint1_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="68.2217"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint2_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="118.929"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint3_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="169.637"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint4_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="220.343"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint5_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="271.052"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint6_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="321.759"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint7_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip3_25382_92306)">
          <g clip-path="url(#clip4_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-938.689 334)"
              fill="#080808"
            />
            <g filter="url(#filter3_f_25382_92306)">
              <circle cx="695.456" cy="752.658" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter4_f_25382_92306)">
              <circle cx="345.944" cy="906.345" r="209.135" fill={background} />
            </g>
            <rect
              x="336.1"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint8_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="386.807"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint9_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="437.514"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint10_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="488.222"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint11_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="538.929"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint12_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="589.637"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint13_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="640.343"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint14_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="691.052"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint15_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="741.759"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint16_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip5_25382_92306)">
          <g clip-path="url(#clip6_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-518.689 334)"
              fill="#080808"
            />
            <g filter="url(#filter6_f_25382_92306)">
              <circle cx="1115.46" cy="752.658" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter7_f_25382_92306)">
              <circle cx="765.944" cy="906.345" r="209.135" fill={background} />
            </g>
            <rect
              x="756.1"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint17_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="806.807"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint18_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="857.514"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint19_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="908.222"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint20_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="958.929"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint21_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1009.64"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint22_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1060.34"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint23_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1111.05"
              y="334"
              width="50.7075"
              height="1095.28"
              fill="url(#paint24_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip7_25382_92306)">
          <g clip-path="url(#clip8_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-1568.69 1256)"
              fill="#080808"
            />
            <g filter="url(#filter9_f_25382_92306)">
              <circle cx="65.4559" cy="1674.66" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter10_f_25382_92306)">
              <circle
                cx="-284.056"
                cy="1828.35"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="-40.3633"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint25_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="10.3428"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint26_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="61.0518"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint27_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="111.759"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint28_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip9_25382_92306)">
          <g clip-path="url(#clip10_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-1148.69 1256)"
              fill="#080808"
            />
            <g filter="url(#filter12_f_25382_92306)">
              <circle cx="485.456" cy="1674.66" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter13_f_25382_92306)">
              <circle cx="135.944" cy="1828.35" r="209.135" fill={background} />
            </g>
            <rect
              x="126.1"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint29_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="176.807"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint30_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="227.514"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint31_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="278.222"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint32_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="328.929"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint33_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="379.637"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint34_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="430.343"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint35_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="481.052"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint36_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="531.759"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint37_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip11_25382_92306)">
          <g clip-path="url(#clip12_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-728.689 1256)"
              fill="#080808"
            />
            <g filter="url(#filter15_f_25382_92306)">
              <circle cx="905.456" cy="1674.66" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter16_f_25382_92306)">
              <circle cx="555.944" cy="1828.35" r="209.135" fill={background} />
            </g>
            <rect
              x="546.1"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint38_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="596.807"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint39_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="647.514"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint40_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="698.222"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint41_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="748.929"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint42_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="799.637"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint43_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="850.343"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint44_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="901.052"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint45_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="951.759"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint46_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip13_25382_92306)">
          <g clip-path="url(#clip14_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-308.689 1256)"
              fill="#080808"
            />
            <g filter="url(#filter18_f_25382_92306)">
              <circle cx="1325.46" cy="1674.66" r="211.353" fill={background} />
            </g>
            <g filter="url(#filter19_f_25382_92306)">
              <circle cx="975.944" cy="1828.35" r="209.135" fill={background} />
            </g>
            <rect
              x="966.1"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint47_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1016.81"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint48_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1067.51"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint49_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1118.22"
              y="1256"
              width="50.7075"
              height="1095.28"
              fill="url(#paint50_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip15_25382_92306)">
          <g clip-path="url(#clip16_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-1568.69 -588)"
              fill="#080808"
            />
            <g filter="url(#filter21_f_25382_92306)">
              <circle
                cx="65.4559"
                cy="-169.342"
                r="211.353"
                fill={background}
              />
            </g>
            <g filter="url(#filter22_f_25382_92306)">
              <circle
                cx="-284.056"
                cy="-15.6547"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="-40.3633"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint51_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="10.3428"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint52_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="61.0518"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint53_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="111.759"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint54_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip17_25382_92306)">
          <g clip-path="url(#clip18_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-1148.69 -588)"
              fill="#080808"
            />
            <g filter="url(#filter24_f_25382_92306)">
              <circle
                cx="485.456"
                cy="-169.342"
                r="211.353"
                fill={background}
              />
            </g>
            <g filter="url(#filter25_f_25382_92306)">
              <circle
                cx="135.944"
                cy="-15.6547"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="126.1"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint55_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="176.807"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint56_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="227.514"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint57_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="278.222"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint58_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="328.929"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint59_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="379.637"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint60_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="430.343"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint61_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="481.052"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint62_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="531.759"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint63_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip19_25382_92306)">
          <g clip-path="url(#clip20_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-728.689 -588)"
              fill="#080808"
            />
            <g filter="url(#filter27_f_25382_92306)">
              <circle
                cx="905.456"
                cy="-169.342"
                r="211.353"
                fill={background}
              />
            </g>
            <g filter="url(#filter28_f_25382_92306)">
              <circle
                cx="555.944"
                cy="-15.6547"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="546.1"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint64_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="596.807"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint65_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="647.514"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint66_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="698.222"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint67_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="748.929"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint68_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="799.637"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint69_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="850.343"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint70_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="901.052"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint71_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="951.759"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint72_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
        <g clip-path="url(#clip21_25382_92306)">
          <g clip-path="url(#clip22_25382_92306)">
            <rect
              width="1719.69"
              height="967.325"
              transform="translate(-308.689 -588)"
              fill="#080808"
            />
            <g filter="url(#filter30_f_25382_92306)">
              <circle
                cx="1325.46"
                cy="-169.342"
                r="211.353"
                fill={background}
              />
            </g>
            <g filter="url(#filter31_f_25382_92306)">
              <circle
                cx="975.944"
                cy="-15.6547"
                r="209.135"
                fill={background}
              />
            </g>
            <rect
              x="966.1"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint73_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1016.81"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint74_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1067.51"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint75_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
            <rect
              x="1118.22"
              y="-588"
              width="50.7075"
              height="1095.28"
              fill="url(#paint76_linear_25382_92306)"
              fill-opacity="0.3"
              style={{ mixBlendMode: "overlay" }}
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_25382_92306"
          x="-85.7144"
          y="391.488"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter1_f_25382_92306"
          x="-433.008"
          y="547.393"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter3_f_25382_92306"
          x="334.286"
          y="391.488"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter4_f_25382_92306"
          x="-13.0084"
          y="547.393"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter6_f_25382_92306"
          x="754.286"
          y="391.488"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter7_f_25382_92306"
          x="406.992"
          y="547.393"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter9_f_25382_92306"
          x="-295.714"
          y="1313.49"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter10_f_25382_92306"
          x="-643.008"
          y="1469.39"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter12_f_25382_92306"
          x="124.286"
          y="1313.49"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter13_f_25382_92306"
          x="-223.008"
          y="1469.39"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter15_f_25382_92306"
          x="544.286"
          y="1313.49"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter16_f_25382_92306"
          x="196.992"
          y="1469.39"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter18_f_25382_92306"
          x="964.286"
          y="1313.49"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter19_f_25382_92306"
          x="616.992"
          y="1469.39"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter21_f_25382_92306"
          x="-295.714"
          y="-530.512"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter22_f_25382_92306"
          x="-643.008"
          y="-374.607"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter24_f_25382_92306"
          x="124.286"
          y="-530.512"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter25_f_25382_92306"
          x="-223.008"
          y="-374.607"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter27_f_25382_92306"
          x="544.286"
          y="-530.512"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter28_f_25382_92306"
          x="196.992"
          y="-374.607"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter30_f_25382_92306"
          x="964.286"
          y="-530.512"
          width="722.341"
          height="722.341"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <filter
          id="filter31_f_25382_92306"
          x="616.992"
          y="-374.607"
          width="717.904"
          height="717.904"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="74.9085"
            result="effect1_foregroundBlur_25382_92306"
          />
        </filter>
        <linearGradient
          id="paint0_linear_25382_92306"
          x1="-33.1934"
          y1="770.085"
          x2="17.5142"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_25382_92306"
          x1="17.5137"
          y1="770.085"
          x2="68.2212"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_25382_92306"
          x1="68.2217"
          y1="770.085"
          x2="118.929"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_25382_92306"
          x1="118.929"
          y1="770.085"
          x2="169.636"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_25382_92306"
          x1="169.637"
          y1="770.085"
          x2="220.344"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_25382_92306"
          x1="220.343"
          y1="770.085"
          x2="271.05"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_25382_92306"
          x1="271.052"
          y1="770.085"
          x2="321.759"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_25382_92306"
          x1="321.759"
          y1="770.085"
          x2="372.466"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_25382_92306"
          x1="336.1"
          y1="770.085"
          x2="386.807"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_25382_92306"
          x1="386.807"
          y1="770.085"
          x2="437.514"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_25382_92306"
          x1="437.514"
          y1="770.085"
          x2="488.221"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_25382_92306"
          x1="488.222"
          y1="770.085"
          x2="538.929"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_25382_92306"
          x1="538.929"
          y1="770.085"
          x2="589.636"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_25382_92306"
          x1="589.637"
          y1="770.085"
          x2="640.344"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_25382_92306"
          x1="640.343"
          y1="770.085"
          x2="691.05"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_25382_92306"
          x1="691.052"
          y1="770.085"
          x2="741.759"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_25382_92306"
          x1="741.759"
          y1="770.085"
          x2="792.466"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_25382_92306"
          x1="756.1"
          y1="770.085"
          x2="806.807"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_25382_92306"
          x1="806.807"
          y1="770.085"
          x2="857.514"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_25382_92306"
          x1="857.514"
          y1="770.085"
          x2="908.221"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_25382_92306"
          x1="908.222"
          y1="770.085"
          x2="958.929"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_25382_92306"
          x1="958.929"
          y1="770.085"
          x2="1009.64"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_25382_92306"
          x1="1009.64"
          y1="770.085"
          x2="1060.34"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_25382_92306"
          x1="1060.34"
          y1="770.085"
          x2="1111.05"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_25382_92306"
          x1="1111.05"
          y1="770.085"
          x2="1161.76"
          y2="770.085"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_25382_92306"
          x1="-40.3633"
          y1="1692.08"
          x2="10.3443"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_25382_92306"
          x1="10.3428"
          y1="1692.08"
          x2="61.0503"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_25382_92306"
          x1="61.0518"
          y1="1692.08"
          x2="111.759"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_25382_92306"
          x1="111.759"
          y1="1692.08"
          x2="162.466"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_25382_92306"
          x1="126.1"
          y1="1692.08"
          x2="176.807"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_25382_92306"
          x1="176.807"
          y1="1692.08"
          x2="227.514"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_25382_92306"
          x1="227.514"
          y1="1692.08"
          x2="278.221"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_25382_92306"
          x1="278.222"
          y1="1692.08"
          x2="328.929"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_25382_92306"
          x1="328.929"
          y1="1692.08"
          x2="379.636"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_25382_92306"
          x1="379.637"
          y1="1692.08"
          x2="430.344"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_25382_92306"
          x1="430.343"
          y1="1692.08"
          x2="481.05"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_25382_92306"
          x1="481.052"
          y1="1692.08"
          x2="531.759"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_25382_92306"
          x1="531.759"
          y1="1692.08"
          x2="582.466"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_25382_92306"
          x1="546.1"
          y1="1692.08"
          x2="596.807"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_25382_92306"
          x1="596.807"
          y1="1692.08"
          x2="647.514"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_25382_92306"
          x1="647.514"
          y1="1692.08"
          x2="698.221"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_25382_92306"
          x1="698.222"
          y1="1692.08"
          x2="748.929"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_25382_92306"
          x1="748.929"
          y1="1692.08"
          x2="799.636"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_25382_92306"
          x1="799.637"
          y1="1692.08"
          x2="850.344"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_25382_92306"
          x1="850.343"
          y1="1692.08"
          x2="901.05"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_25382_92306"
          x1="901.052"
          y1="1692.08"
          x2="951.759"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_25382_92306"
          x1="951.759"
          y1="1692.08"
          x2="1002.47"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_25382_92306"
          x1="966.1"
          y1="1692.08"
          x2="1016.81"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_25382_92306"
          x1="1016.81"
          y1="1692.08"
          x2="1067.51"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_25382_92306"
          x1="1067.51"
          y1="1692.08"
          x2="1118.22"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_25382_92306"
          x1="1118.22"
          y1="1692.08"
          x2="1168.93"
          y2="1692.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_25382_92306"
          x1="-40.3633"
          y1="-151.915"
          x2="10.3443"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_25382_92306"
          x1="10.3428"
          y1="-151.915"
          x2="61.0503"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_25382_92306"
          x1="61.0518"
          y1="-151.915"
          x2="111.759"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_25382_92306"
          x1="111.759"
          y1="-151.915"
          x2="162.466"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_25382_92306"
          x1="126.1"
          y1="-151.915"
          x2="176.807"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_25382_92306"
          x1="176.807"
          y1="-151.915"
          x2="227.514"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_25382_92306"
          x1="227.514"
          y1="-151.915"
          x2="278.221"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_25382_92306"
          x1="278.222"
          y1="-151.915"
          x2="328.929"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_25382_92306"
          x1="328.929"
          y1="-151.915"
          x2="379.636"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_25382_92306"
          x1="379.637"
          y1="-151.915"
          x2="430.344"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_25382_92306"
          x1="430.343"
          y1="-151.915"
          x2="481.05"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_25382_92306"
          x1="481.052"
          y1="-151.915"
          x2="531.759"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_25382_92306"
          x1="531.759"
          y1="-151.915"
          x2="582.466"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_25382_92306"
          x1="546.1"
          y1="-151.915"
          x2="596.807"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_25382_92306"
          x1="596.807"
          y1="-151.915"
          x2="647.514"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_25382_92306"
          x1="647.514"
          y1="-151.915"
          x2="698.221"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_25382_92306"
          x1="698.222"
          y1="-151.915"
          x2="748.929"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_25382_92306"
          x1="748.929"
          y1="-151.915"
          x2="799.636"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_25382_92306"
          x1="799.637"
          y1="-151.915"
          x2="850.344"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_25382_92306"
          x1="850.343"
          y1="-151.915"
          x2="901.05"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_25382_92306"
          x1="901.052"
          y1="-151.915"
          x2="951.759"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_25382_92306"
          x1="951.759"
          y1="-151.915"
          x2="1002.47"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_25382_92306"
          x1="966.1"
          y1="-151.915"
          x2="1016.81"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_25382_92306"
          x1="1016.81"
          y1="-151.915"
          x2="1067.51"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_25382_92306"
          x1="1067.51"
          y1="-151.915"
          x2="1118.22"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_25382_92306"
          x1="1118.22"
          y1="-151.915"
          x2="1168.93"
          y2="-151.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="0.8125" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_25382_92306">
          <rect width="1132" height="1600" fill="white" />
        </clipPath>
        <clipPath id="clip1_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(-69 334)"
          />
        </clipPath>
        <clipPath id="clip2_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-1358.69 334)"
          />
        </clipPath>
        <clipPath id="clip3_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(351 334)"
          />
        </clipPath>
        <clipPath id="clip4_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-938.689 334)"
          />
        </clipPath>
        <clipPath id="clip5_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(771 334)"
          />
        </clipPath>
        <clipPath id="clip6_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-518.689 334)"
          />
        </clipPath>
        <clipPath id="clip7_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(-279 1256)"
          />
        </clipPath>
        <clipPath id="clip8_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-1568.69 1256)"
          />
        </clipPath>
        <clipPath id="clip9_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(141 1256)"
          />
        </clipPath>
        <clipPath id="clip10_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-1148.69 1256)"
          />
        </clipPath>
        <clipPath id="clip11_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(561 1256)"
          />
        </clipPath>
        <clipPath id="clip12_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-728.689 1256)"
          />
        </clipPath>
        <clipPath id="clip13_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(981 1256)"
          />
        </clipPath>
        <clipPath id="clip14_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-308.689 1256)"
          />
        </clipPath>
        <clipPath id="clip15_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(-279 -588)"
          />
        </clipPath>
        <clipPath id="clip16_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-1568.69 -588)"
          />
        </clipPath>
        <clipPath id="clip17_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(141 -588)"
          />
        </clipPath>
        <clipPath id="clip18_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-1148.69 -588)"
          />
        </clipPath>
        <clipPath id="clip19_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(561 -588)"
          />
        </clipPath>
        <clipPath id="clip20_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-728.689 -588)"
          />
        </clipPath>
        <clipPath id="clip21_25382_92306">
          <rect
            width="430"
            height="932"
            fill="white"
            transform="translate(981 -588)"
          />
        </clipPath>
        <clipPath id="clip22_25382_92306">
          <rect
            width="1719.69"
            height="967.325"
            fill="white"
            transform="translate(-308.689 -588)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Preview2Back;
